<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- Bookmarks Container -->
      <bookmarks />
    </div>

    <b-navbar-nav class="nav align-items-center flex-nowrap ml-auto">
      <locale />
      <dark-Toggler class="d-none d-lg-block" />
      <!-- <search-bar /> -->
      <cart-dropdown />
      <notification-dropdown />
      <!-- <user-dropdown /> -->
      <!-- <b-button
        v-if="!shortAddress"
        variant="primary"
        class="ml-3"
        @click="connect"
      >
        <feather-icon
          icon="KeyIcon"
          class="mr-50"
        />
        <span class="align-middle">Connect</span>
      </b-button> -->

      <!-- <b-nav-item-dropdown
        v-else
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <b-link>{{ shortAddress }}</b-link>
        </template>
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="disconnect"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Disconnect</span>
        </b-dropdown-item>
      </b-nav-item-dropdown> -->
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BButton, BNavItemDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    UserDropdown,
    BButton,
    BNavItemDropdown,
    BDropdownItem,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => { },
    },
  },
  computed: {
    ...mapGetters('wallet', ['shortAddress']),
  },
  methods: {
    ...mapActions('wallet', ['connect', 'disconnect', 'accountSelect']),
  },
}
</script>
